import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  checkEventTemplate,
  updateWebsiteLiveStatus,
  fetchSiteDetails,
  makeFresh,
} from "TemplatesAction";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
import { confirmAlert } from "react-confirm-alert";

class Ticketdashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      copied: false,
    };
  }

  componentDidMount() {
    this.props.checkEventTemplate(this.props.session);

    // console.log("BEFORE CALL: fetchSiteDetails DASHBOARD");

    this.props.fetchSiteDetails(this.props.session);

    setTimeout(() => {
      // console.log("AFTER CALL: fetchSiteDetails DASHBOARD");
    }, 1000);
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  redirectUrl = (e) => {
    let step = e.currentTarget.dataset.data_id;
    if (step == "Step1") {
      var path = "themes";
      this.props.history.push(`/dashboard/website/${path}`);
    } else if (step == "Step2") {
      var path = "settings";
      this.props.history.push(`/dashboard/website/${path}`);
    }
  };

  chnageWebsiteLiveMode = () => {
    let { eventSelectedTemplate } = this.props;
    let status = 1;
    let id = 0;
    if (eventSelectedTemplate && eventSelectedTemplate.length > 0) {
      status = !eventSelectedTemplate[0].isenabled;
      id = eventSelectedTemplate[0].id;
    }

    this.props.updateWebsiteLiveStatus(
      this.props.session,
      status,
      id,
      (response) => {
        if (response.success) {
          this.props.checkEventTemplate(this.props.session);
        }
      }
    );
  };

  /**
   * =============================================================================================
   */

  viewSite = (e) => {
    let { siteDetails } = this.props;

    let siteURL =
      // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
      "http://staging.teks.co.in/udayan/preview/index";

    window.open(siteURL, "_blank");
  };

  viewWpadmin = (e) => {
    let { siteDetails } = this.props;

    let siteURL =
      "https://" +
      siteDetails.resource[0].website_subdomain +
      ".eventify.io/wp-admin";

    window.open(siteURL, "_blank");
  };

  redirectToWizard = () => {
    var path = "wizard";
    this.props.history.push(`/dashboard/website/${path}`);
  };

  makeFresh = () => {
    confirmAlert({
      title: "Are you sure?",
      message:
        "Your entire site details along with domain settings will be erased. Once you click yes you can not rollback to previous domain settings.",
      confirmLabel: "Yes",
      cancelLabel: "No",
      buttons: [
        {
          label: LocaleStrings.button_yes,
          onClick: () => {
            this.props.makeFresh(this.props.session, (res) => {
              if (res.success) {
                this.props.fetchSiteDetails(this.props.session);
                setTimeout(() => {
                  this.redirectToWizard();
                }, 100);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_no,
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    let { eventSelectedTemplate, siteDetails, deviceSize } = this.props;

    let templateValidationStyle = "steps-icon-not-filled";
    let settingValidationStyle = "steps-icon-not-filled";

    let templateIcon = "fa fa-exclamation-circle";
    let settingIcon = "fa fa-exclamation-circle";
    let template = false;
    let setting = false;
    let website = "";

    if (eventSelectedTemplate && eventSelectedTemplate.length > 0) {
      templateValidationStyle = "steps-icon-filled";
      templateIcon = "fa fa-check-circle";
      template = true;
    }

    if (
      eventSelectedTemplate &&
      eventSelectedTemplate.length > 0 &&
      eventSelectedTemplate[0].website_subdomain &&
      eventSelectedTemplate[0].website_url
    ) {
      settingValidationStyle = "steps-icon-filled";
      settingIcon = "fa fa-check-circle";
      setting = true;
      website = eventSelectedTemplate[0].website_url;
    }

    let checked = false;
    if (eventSelectedTemplate && eventSelectedTemplate.length > 0) {
      checked = eventSelectedTemplate[0].isenabled;
    }

    let dummy = "";

    let siteURL = "";
    let wpadminURL = "";
    if (
      siteDetails &&
      siteDetails.resource &&
      !_.isEmpty(siteDetails.resource) &&
      siteDetails.resource[0].website_subdomain
    ) {
      siteURL =
        // "https://" + siteDetails.resource[0].website_subdomain + ".eventify.io";
        "http://staging.teks.co.in/udayan/preview/index";
      wpadminURL =
        "https://" +
        siteDetails.resource[0].website_subdomain +
        ".eventify.io/wp-admin";
    }

    return (
      <div
        className="panel-body scrollable-content"
        // style={{ height: deviceSize.height - 70 }}
      >
        <div className="template-dashboard">
          {/* New Dashbord changes */}
          <label className="heading-theme-text-color">
            Here is your site details
          </label>
          <div className="row m-0" style={{ width: "70%" }}>
            <div
              className="col-md-12 p-0"
              style={{
                border: "solid 1px #A9ABB5",
                borderRadius: 10,
                marginTop: 12,
              }}>
              <div className="p-20">
                <label className="heading-theme-text-color ">
                  Existing site
                </label>
                <div className="pull-right">
                  {/* <Button className="btn-custom-blue schedule-add-button"  > */}
                  {/* <img  style={{paddingRight:10,paddingBottom:3 }} src='../../style/images/header-icons/plus.png'></img>Login */}
                  {/* Publish */}
                  {/* </Button> */}
                </div>
                <div className="row m-0">
                  <div
                    className="col-md-12"
                    style={{
                      border: "solid 1px #A9ABB5",
                      borderRadius: 10,
                      marginTop: 10,
                      padding: "40px 15px",
                      backgroundColor: "#FFF",
                    }}>
                    <div className="col-md-8">
                      <div>
                        <label className="heading-theme-text-color">
                          Website URL
                        </label>
                      </div>

                      {/* <div><label className='control-label-top' style={{ color: '#5A97EF', fontWeight: 500 }}> { siteURL ? siteURL : "No website added yet."} </label></div> */}
                      <div>
                        <label
                          className="control-label-top"
                          style={{
                            color: "#6a54c9",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                          onClick={(e) => this.viewSite()}>
                          {" "}
                          {siteURL}{" "}
                        </label>
                      </div>
                    </div>

                    {/* {siteURL ? (
                    <div
                      className="col-md-4 text-center"
                      style={{ paddingTop: 8 }}
                    >
                      <Button
                        
                        className="btn-custom-blue-website-dashboard"
                        loading={this.state.loading}
                        disabled={false}
                        onClick={(e) => this.viewSite()}
                      >
                        {" "}
                        View Site{" "}
                      </Button>
                    </div>
                  ) : (
                    <div
                      className="col-md-4 text-center"
                      style={{ paddingTop: 8 }}
                    >
                      <Button
                        
                        className="btn-custom-blue-website-dashboard"
                        loading={this.state.loading}
                        disabled={false}
                        onClick={(e) => this.redirectToWizard()}
                      >
                        {" "}
                        Add Site{" "}
                      </Button>
                    </div>
                  )} */}

                    <div
                      className="col-md-4 text-center"
                      style={{ paddingTop: 8, paddingLeft: 3 }}>
                      <Button
                        className="btn-custom-blue-website-dashboard"
                        loading={this.state.loading}
                        disabled={false}
                        onClick={(e) => this.viewSite()}>
                        {" "}
                        View Site{" "}
                      </Button>
                    </div>
                  </div>

                  {/* <div
                    className="col-md-12"
                    style={{
                      border: "solid 1px #A9ABB5",
                      borderRadius: 10,
                      marginTop: 20,
                      padding: "40px 15px",
                      backgroundColor: "#FFF",
                    }}
                  >
                    <div className="col-md-8">
                      <div>
                        <label className="heading-theme-text-color">
                          Login To WordPress Admin
                        </label>
                      </div>
                      <div>
                        <label
                          className="control-label-top"
                          style={{
                            color: "#6a54c9",
                            fontWeight: 500,
                            cursor: "pointer",
                          }}
                          onClick={(e) => this.viewWpadmin()}
                        >
                          {wpadminURL}
                        </label>
                      </div>
                    </div>
                    <div
                      className="col-md-4 text-center"
                      style={{ paddingTop: 8 }}
                    >
                      <Button
                        
                        className="btn-custom-blue-website-dashboard"
                        loading={this.state.loading}
                        disabled={false}
                        onClick={(e) => this.viewWpadmin()}
                      >
                        View Admin
                      </Button>
                    </div>
                  </div> */}
                </div>

                {/* <label className="heading-theme-text-color mt-20">
                  Make a new site
                </label> */}
                {/* <div className="row m-0">
                  <div
                    className="col-md-12"
                    style={{
                      border: "solid 1px #A9ABB5",
                      borderRadius: 10,
                      marginTop: 10,
                      padding: "40px 15px",
                      backgroundColor: "#FFF",
                      cursor: "pointer",
                    }}
                    onClick={(e) => this.makeFresh()}
                  >
                    <div className="col-md-8">
                      <div>
                        <label className="heading-theme-text-color">
                          Make fresh from wizard
                        </label>
                      </div>
                      <div>
                        <label
                          className="control-label-top"
                          style={{ color: "#9799A4", fontWeight: 500 }}
                        >
                          Your entire site details along with domain settings
                          will be erased. You have to purchase a fresh plan to
                          activate site.
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="col-md-12 text-center">
                        <i
                          className="fa fa-angle-right"
                          style={{
                            fontSize: 32,
                            color: "#000000",
                            marginTop: 24,
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Old Dashboard */}
          {/* <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12">
            {template && setting ? (
              <div style={{ marginBottom: 20 }}>
                <div className="template-dashboard-template-main-div">
                  <h4 className="heading-para">
                    {LocaleStrings.website_dashboard_text_your_event_live}
                  </h4>
                  <p className="promote-para">
                    {
                      LocaleStrings.website_dashboard_text_your_event_live_sub_title
                    }
                  </p>
                  <div className="row">
                    <div className="col-md-10">
                      <div className="copy-template-page">
                        <div className="website-url">{website}</div>
                        <CopyToClipboard text={website} onCopy={this.copyUrl}>
                          <div className="url-copy">
                            <i
                              className="fa fa-files-o i-custom-m"
                              aria-hidden="true"
                            ></i>
                            {LocaleStrings.button_copy}
                          </div>
                        </CopyToClipboard>
                      </div>
                      {this.state.copied ? (
                        <span style={{ color: "black", float: "right" }}>
                          {LocaleStrings.copied}.
                        </span>
                      ) : null}
                    </div>
                    <div
                      className="col-md-2"
                      style={{ paddingLeft: 0, paddingTop: 2 }}
                    >
                      <a
                        href={website}
                        target="blank"
                        className="btn btn-custom-blue"
                      >
                        <span aria-hidden="true">
                          {LocaleStrings.button_visit}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="template-dashboard-website-live-main-div">
                  <div className="live-text">
                    {LocaleStrings.website_dashboard_text_website_live_now}
                  </div>
                  <div className="live-action">
                    <label
                      className="template-live-switch"
                      style={{ marginTop: 2 }}
                    >
                      <input
                        type="checkbox"
                        onChange={this.chnageWebsiteLiveMode}
                        checked={checked}
                      />
                      <span className="template-live-slider template-live-round"></span>
                    </label>
                  </div>
                </div>
              </div>
            ) : null}

            <div style={{ fontSize: 14, marginBottom: 10 }}>
              {LocaleStrings.website_dashboard_text_things_to_do_for_website}
            </div>
            <div className="template-dashboard-steps-main-div">
              <div
                className="dashboard-steps"
                data-data_id="Step1"
                onClick={this.redirectUrl}
              >
                <div className={templateValidationStyle}>
                  <i className={templateIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.website_dashboard_text_things_to_do_1}
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.website_dashboard_text_things_to_do_1_sub_title
                    }
                  </p>
                </div>
                <div className="steps-icon-arrow">
                  <i
                    className="fa fa-chevron-circle-right"
                    aria-hidden="false"
                  ></i>
                </div>
              </div>
              <div
                className="dashboard-steps"
                data-data_id="Step2"
                onClick={this.redirectUrl}
              >
                <div className={settingValidationStyle}>
                  <i className={settingIcon} aria-hidden="true"></i>
                </div>
                <div style={{ width: "88%" }}>
                  <h4 className="heading-para">
                    {LocaleStrings.website_dashboard_text_things_to_do_2}
                  </h4>
                  <p className="description-para">
                    {
                      LocaleStrings.website_dashboard_text_things_to_do_2_sub_title
                    }
                  </p>
                </div>
                <div className="steps-icon-arrow">
                  <i
                    className="fa fa-chevron-circle-right"
                    aria-hidden="false"
                  ></i>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventSelectedTemplate: state.eventSelectedTemplate,
    siteDetails: state.siteDetails,
    redeploy: state.redeploy,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  checkEventTemplate,
  updateWebsiteLiveStatus,
  fetchSiteDetails,
  makeFresh,
})(Ticketdashboard);
